import {
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/podkit/select/Select";
import type { SelectableTimeRange, TimeRange } from "@/routes/insights/insights";

type Props = {
    timeRanges: SelectableTimeRange[];
    selectedRange: TimeRange;
    setSelectedRange: (range: TimeRange) => void;
};
export const TimeRangeSelector = ({ timeRanges, selectedRange, setSelectedRange }: Props) => {
    return (
        <div className="w-full">
            <Select
                value={selectedRange.label}
                onValueChange={(value) => {
                    const range = timeRanges.find((r) => r.label === value);
                    if (range) {
                        setSelectedRange(range);
                    }
                }}
            >
                <SelectTrigger loading={false}>
                    <SelectValue placeholder="Select time range" />
                </SelectTrigger>
                <SelectContent>
                    <SelectGroup>
                        {timeRanges.map((range) => (
                            <SelectItem key={range.label} value={range.label} disabled={range.disabled}>
                                <span>{range.label}</span>
                            </SelectItem>
                        ))}
                    </SelectGroup>
                </SelectContent>
            </Select>
        </div>
    );
};
